import cn from "classnames";
import styles from "./Preview.module.scss";

export const APAPreview = () => (
  <div className={cn(styles.preview, styles.previewAPA)}>
    <div className={styles.top}>
      <div className={cn(styles.tag, styles.tagRunningHead)}>Running head</div>
      <div className={styles.tag}>Title of your work</div>
      <div className={styles.title}>APA formatting example</div>
    </div>

    <div className={styles.bottom}>
      <div className={styles.tag}>Your name</div>
      <div className={styles.tag}>Institution</div>
      <div className={styles.tag}>Course name</div>
      <div className={styles.tag}>Instructor’s name</div>
      <div className={styles.tag}>Due date</div>
    </div>
  </div>
);
